export default function (value) {
  if (typeof (value) === 'undefined' || value === null) {
    return ''
  }

  return value.toString().replace('.', ',')
}
